import React from 'react';

export default ({ data }) => {
    let eventCopy = data === 1 ? 'Event' : 'Events';
    return (
        <div>
            <div className="dashboard-count">{data}</div>
            <div className="dashboard-title">{eventCopy} Today</div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/dashboard/events-today.js